import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { API } from '@models/API/index';

import { platformAPI } from '@services/API/endpoints';

@Injectable({ providedIn: 'root' })
export class IdentityInvitationsAPI {
  constructor(private http: HttpClient) {}

  validateInvitationCode(
    invitationCode: string,
    loaderOptIn: boolean | string = true
  ) {
    return this.http.get<API.Identity.Invitations.ValidateCode.Response>(
      platformAPI.identity.invitations.invitationCode(invitationCode),
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
        }),
      }
    );
  }
}
